import {Button, Card, Col, Form, message, Modal, Row, Space, Spin} from 'antd';
import LeftSideDetailsCollapse from "../../../components/admin/documentanddetailsverification/leftSideCollapse";
import {useEffect, useRef, useState} from "react";
import {WorkbasketTableDto} from "../../../dto/admin/WorkbasketTableDto";
import adminService from "../../../service/adminService";
import {
    MSG_FAILED_TO_FETCH_CUSTOMER_DETAILS_ERROR,
    MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR, MSG_NIC_BOTH_COMPARE_WARN,
    MSG_NIC_FRONT_COMPARE_WARN,
    MSG_NIC_REAR_COMPARE_WARN,
    MSG_PASSPORT_DETAIL_COMPARE_WARN,
    MSG_UPLOAD_BOTH_NIC_IMAGES_WARN,
    MSG_UPLOAD_PASSPORT_DOC_WARN,
    MSG_UPLOAD_PEP_STATUS_DOC_WARN
} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import RightSideDocument from "../../../components/admin/documentanddetailsverification/rightSideDocument";
import './style.scss'
import {
    ADMIN_NEEDED_DOCUMENT_LIST,
    ADMIN_VERIFICATION_TYPE,
    CUSTOMER_VERIFICATION_STATUS,
    IDENTIFICATION_SOURCE
} from "../../../util/Constants";
import TextArea from "antd/es/input/TextArea";
import {AdminRequestDto} from "../../../dto/admin/AdminRequestDto";
import {useHistory} from "react-router-dom";
import {DocumentVerificationStatusDto} from "../../../dto/admin/DocumentVerificationStatusDto";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import modal from "antd/es/modal";
import {CheckCircleOutlined, StopOutlined} from '@ant-design/icons/lib';
import {CustomerDto} from "../../../dto/CustomerDto";
import documentService from "../../../service/documentService";
import {Error500Page} from "../../../components/common/errorPages/error500Page";


export default function DocumentAndDetailsVerification(props: any) {
    const [dataDto, setDataDto] = useState<WorkbasketTableDto>();
    const [customerDto, setCustomerDto] = useState<CustomerDto>();
    const [documentList, setDocumentList] = useState();
    const [isSpinnerLoading, setSpinnerLoading] = useState<boolean>(false);
    const [isLeftCompLoading, setLeftCompLoading] = useState<boolean>(false);
    const [isRightCompLoading, setRightCompLoading] = useState<boolean>(false);
    const [isRemarkModalOpen, setRemarkModalOpen] = useState<boolean>(false);
    const [documentVerificationStatusDto, setDocumentVerificationStatusDto] = useState<DocumentVerificationStatusDto>();
    const childRef = useRef();
    let history = useHistory();
    let [rejectForm] = Form.useForm();
    useEffect(() => {
        const workBasketDataStr = localStorage.getItem("workBasketData");
        const workbasketDto = workBasketDataStr !== null ? JSON.parse(workBasketDataStr) : null;
        setDataDto(workbasketDto)
        getCustomerDetails(workbasketDto);
        getDocumentDetailListByCustomer(workbasketDto);
    }, [props.history.location.state])

    const getCustomerDetails = (workbasketDto: WorkbasketTableDto) => {
        setLeftCompLoading(true)
        adminService.getCustomerDetailsForVerification(workbasketDto.workId).then(res => {
            if (res.data !== null) {
                console.log(res.data.results)
                let customerMstDto = res.data.results.customerMstDto;
                setCustomerDto(customerMstDto)
                // setAdminWrapperDto({customerMstDto: customerMstDto})
                setLeftCompLoading(false)
            } else {
                setLeftCompLoading(false)
                message.error(MSG_FAILED_TO_FETCH_CUSTOMER_DETAILS_ERROR).then();
            }
        }, (reason) => {
            setLeftCompLoading(false)
            ErrorHandler.handleError(reason);
        })
    }


    const getDocumentDetailListByCustomer = (workbasketDto: WorkbasketTableDto) => {
        setRightCompLoading(true)
        documentService.getUploadDocumentListByType(workbasketDto.customerId, ADMIN_NEEDED_DOCUMENT_LIST).then(res => {
            if (res.data !== null) {
                setDocumentList(res.data.results)
                setRightCompLoading(false)
            } else {
                setRightCompLoading(false)
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
            }
        }, (reason) => {
            setRightCompLoading(false)
            ErrorHandler.handleError(reason);
        })
    }


    const handleCancel = () => {
        setRemarkModalOpen(false)
    }

    const submitReject = (value: { rejectReason: string | undefined, internalRemark: string | undefined }) => {
        let adminRequestDto = {
            adminWorkType: ADMIN_VERIFICATION_TYPE.CUSTOMER_DETAIL_VERIFICATION,
            customerVerificationStatus: CUSTOMER_VERIFICATION_STATUS.REJECTED,
            rejectReason: value.rejectReason,
            internalRemark: value.internalRemark,
            workId: undefined != dataDto ? dataDto?.workId : 0,
            // politicallyExposedStatus: documentVerificationStatusDto?.pepStatus
        } as AdminRequestDto
        submitRequest(CUSTOMER_VERIFICATION_STATUS.REJECTED, adminRequestDto)
    }

    const submitRequest = (type: CUSTOMER_VERIFICATION_STATUS, adminRequestDto: AdminRequestDto) => {
        handleCancel()
        setSpinnerLoading(true)
        adminService.verifyDetail(adminRequestDto).then((res) => {
            if (res.data !== null) {
                message.success(`Task ${type === CUSTOMER_VERIFICATION_STATUS.REJECTED ? "rejected" : "verified"} successfully`).then(() => {
                    history.push('/workflow/admin/documentVerificationWorkBasket')
                })
            } else {
                message.error(`Task ${type === CUSTOMER_VERIFICATION_STATUS.REJECTED ? "rejection" : "verification"} failure`)
                setSpinnerLoading(false)
            }
        }).catch(reason => {
            setSpinnerLoading(false)
            ErrorHandler.handleError(reason)
        })
    }

    const validateVerifyOrReject = (documentVerificationStatusDto: DocumentVerificationStatusDto): boolean => {
        let canSubmit: boolean = false
        if (IDENTIFICATION_SOURCE.NIC === documentVerificationStatusDto.identificationSourceType) {
            if (!documentVerificationStatusDto.nicFrontDocumentStatus || !documentVerificationStatusDto.nicRearDocumentStatus) {
                message.warning(MSG_UPLOAD_BOTH_NIC_IMAGES_WARN);
                canSubmit = false;
            } else if (!documentVerificationStatusDto.pepDocumentStatus) {
                message.warning(MSG_UPLOAD_PEP_STATUS_DOC_WARN)
                canSubmit = false;
            } else if (!documentVerificationStatusDto.nicFrontCompared && !documentVerificationStatusDto.nicRearCompared){
                message.warning(MSG_NIC_BOTH_COMPARE_WARN);
                canSubmit = false;
            } else if (!documentVerificationStatusDto.nicFrontCompared){
                message.warning(MSG_NIC_FRONT_COMPARE_WARN);
                canSubmit = false;
            } else if (!documentVerificationStatusDto.nicRearCompared){
                message.warning(MSG_NIC_REAR_COMPARE_WARN);
                canSubmit = false;
            } else if (null == documentVerificationStatusDto.pepStatus) {
                canSubmit = false;
            } else {
                canSubmit = true;
            }

        } else if (IDENTIFICATION_SOURCE.PP === documentVerificationStatusDto.identificationSourceType) {
            if (!documentVerificationStatusDto.passportDocumentStatus) {
                message.warning(MSG_UPLOAD_PASSPORT_DOC_WARN)
                canSubmit = false;
            } else if (!documentVerificationStatusDto.pepDocumentStatus) {
                message.warning(MSG_UPLOAD_PEP_STATUS_DOC_WARN)
                canSubmit = false;
            }else if (!documentVerificationStatusDto.passportDetailCompared) {
                message.warning(MSG_PASSPORT_DETAIL_COMPARE_WARN)
                canSubmit = false;
            } else if (null == documentVerificationStatusDto.pepStatus) {
                canSubmit = false;
            } else {
                canSubmit = true;
            }
        } else {
            if (!documentVerificationStatusDto.pepDocumentStatus) {
                message.warning(MSG_UPLOAD_PEP_STATUS_DOC_WARN)
                canSubmit = false;
            } else if (null == documentVerificationStatusDto.pepStatus) {
                canSubmit = false;
            } else {
                canSubmit = true;
            }
        }
        return canSubmit;
    }
    const documentDetailVerifyOrReject = (type: CUSTOMER_VERIFICATION_STATUS) => {
        let rejected = type === CUSTOMER_VERIFICATION_STATUS.REJECTED;
        if (undefined !== childRef?.current) {
            let documentVerificationStatusDto: DocumentVerificationStatusDto = (childRef?.current as any)?.passData(rejected);
            setDocumentVerificationStatusDto(documentVerificationStatusDto)
            if (rejected ? true : validateVerifyOrReject(documentVerificationStatusDto)) {
                modal.confirm({
                    title: 'Confirm',
                    icon: <ExclamationCircleOutlined/>,
                    content: `Are you sure you want to ${rejected ? "reject" : "verify"} the job?`,
                    okText: 'Yes',
                    cancelText: 'No',
                    className: 'confirm-dialog-box',
                    okButtonProps: {style: {background: '#FF7400'}},
                    onOk() {

                        if (rejected) {
                            setRemarkModalOpen(true)
                        } else {
                            let adminRequestDto = {
                                adminWorkType: ADMIN_VERIFICATION_TYPE.CUSTOMER_DETAIL_VERIFICATION,
                                customerVerificationStatus: CUSTOMER_VERIFICATION_STATUS.VERIFIED,
                                workId: dataDto?.workId,
                                politicallyExposedStatus: documentVerificationStatusDto.pepStatus
                            } as AdminRequestDto
                            submitRequest(type, adminRequestDto);
                        }
                    },
                });
            }
        }

    }


    return (
        <div>
            {isSpinnerLoading ?
                <div className="loader-container">
                    <Spin size="large" tip="Loading"></Spin>
                </div>
                :
                <div>
                    <Row gutter={[32, 32]}>
                        <Col xl={12} lg={12} sm={24}>
                            <Card title="Details Entered by the Customer"
                                  className='document_and_details_verification_card'
                                  size='small'>
                                {isLeftCompLoading ?
                                    <div className="custom_loader_styles">
                                        <Spin size="large" tip="Loading"></Spin>
                                    </div>
                                    :
                                    customerDto && <LeftSideDetailsCollapse dataDto={customerDto}/>
                                }


                            </Card>
                        </Col>
                        <Col xl={12} lg={12} sm={24}>
                            <Card title="Documents Uploaded by the Customer"
                                  className='document_and_details_verification_card' size='small'>
                                {isRightCompLoading ?
                                    <div className=" custom_loader_styles">
                                        <Spin size="large" tip="Loading"></Spin>
                                    </div>
                                    :
                                    documentList ? <RightSideDocument isCompareView={true} ref={childRef} dataDto={{
                                            customerMstDto: customerDto,
                                            documentDtoList: documentList
                                        }} workBasketDto={dataDto}/> :
                                        <Error500Page/>
                                }

                            </Card>
                        </Col>

                    </Row>
                    <Row className='doc-approve-reject-btns'>
                        <Col span={24}>
                            {documentList && <Space>
                                <Button
                                    // className='reject-btn'
                                    disabled={isRightCompLoading}
                                    type="primary" danger
                                    onClick={() => documentDetailVerifyOrReject(CUSTOMER_VERIFICATION_STATUS.REJECTED)}>
                                    <StopOutlined/> Reject
                                </Button>
                                <Button
                                    // className='verify-btn'
                                    disabled={isRightCompLoading}
                                    htmlType="submit" type="primary"
                                    onClick={() => documentDetailVerifyOrReject(CUSTOMER_VERIFICATION_STATUS.VERIFIED)}>
                                    <CheckCircleOutlined/> Verify
                                </Button>
                            </Space>}
                        </Col>
                    </Row>
                </div>}
            <Modal destroyOnClose={true}
                   maskClosable={false}
                   title="Reject Reason / Internal Remark"
                   open={isRemarkModalOpen}
                   footer={[]}
                   onCancel={handleCancel}
            >

                <Form
                    className='form-input attachments-upload-form'
                    layout={"vertical"}
                    form={rejectForm}
                    onFinish={submitReject}
                    preserve={false}
                >
                    <Form.Item
                        name={"rejectReason"}
                        label={<b>Reject Reason</b>}
                        rules={[{
                            required: true,
                            message: 'Please enter reject reason'
                        }]}>
                        <TextArea showCount placeholder="Please enter reject reason" maxLength={255}
                                  bordered={true}/>
                    </Form.Item>
                    <Form.Item
                        name={"internalRemark"}
                        label={<b>Internal Remark</b>}>
                        <TextArea showCount placeholder="Please enter internal remark" maxLength={255}
                                  bordered={true}/>
                    </Form.Item>
                    <Form.Item>
                        <Space style={{float: 'right'}}>
                            <Button htmlType="submit" type="success"
                                    style={{background: "#FF7400", color: "white", marginTop: 12}}>Submit</Button>
                        </Space>
                    </Form.Item>


                </Form>
            </Modal>
        </div>
    );
}
